import { ViewportScroller } from '@angular/common';
import { Injectable, inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CommonAccordionService {
    private viewportScroller = inject(ViewportScroller);

    public scrollToAccordion(accordionName: string) {
        setTimeout(() => {
            this.viewportScroller.scrollToAnchor(accordionName + '-title');
        }, 100);
    }
}
